// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__stoLn","title":"styles_title__32s9v"};